import React from 'react';
import { FormikValues } from 'formik';
import { FORM_VALUE_ENUM } from './constant';
import { FieldTextElem } from '../../common/field-text';
import { ButtonElem } from '../../common/button';
import { LoaderElem } from '../../common/loader';
import { AlertActionElem } from '../../common/alert-action';
import { FormElem } from '../../common/form';
import styled from 'styled-components';
import { Spacing } from '../../theme';
import { i18n } from '../../lib/lang';
import { ContentContainerElem } from '../../common/content-container';
import { DoubleContainerElem } from '../../common/double-container';
import { GridElem } from '../../common/grid';
import { TextElem } from '../../common/text';
import sendIcon from '../../asset/svg/button/invite.svg';
import { FieldPasswordElem } from '../../common/field-password';
import { SelectElem } from '../../common/select';
import { USER_ROLE_OPTION_LIST } from '../../data/user/constant';
import { COLOR_ENUM } from '../../theme/color';
import {
  SIZE_BORDER_RADIUS_DATA,
  SIZE_BORDER_RADIUS_ENUM,
} from '../../theme/size';
import { ReactComponent as AddIconLarge } from '../../asset/svg/common/add.svg';
import { ReactComponent as CloseIcon } from '../../asset/svg/common/close.svg';
import { convertProjectListToSelect } from '../../data/project/convert';
import { getProjectList } from '../../data/project/action';
import { SelectPreloadContainer } from '../select-preload';
import { FieldNumberElem } from '../../common/field-number';

export const Component: React.FC<{
  formik: FormikValues;
  isFieldError: Function;
  getFieldError: Function;
  isSubmitDisabled: Function;
  getFieldValue: Function;
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
  setFieldValue: Function;
  setValue: Function;
  formVisible: boolean;
  setFormVisible: Function;
}> = ({
  formik,
  isFieldError,
  getFieldError,
  isSubmitDisabled,
  getFieldValue,
  isLoading,
  isSuccess,
  isError,
  errorMessage,
  setFieldValue,
  setValue,
  formVisible,
  setFormVisible,
}) => {
  const closeModal = () => {
    formik.resetForm();

    setFormVisible(false);
  };
  return (
    <>
      {formVisible ? (
        <FormElem onSubmit={formik.handleSubmit}>
          {isLoading && <LoaderElem />}
          <ContentContainerElem>
            <GridElem spacing={5}>
              <TitleContainer>
                <TextElem
                  tid="USER.CREATE.TITLE"
                  type="semi-bold"
                  size="main"
                />
                <CloseIcon onClick={closeModal} style={{ cursor: 'pointer' }} />
              </TitleContainer>
              <DoubleContainerElem>
                <FieldTextElem
                  name={FORM_VALUE_ENUM.EMAIL}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  title="USER.CREATE.FORM.EMAIL"
                  value={getFieldValue(FORM_VALUE_ENUM.EMAIL)}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.EMAIL)}
                  error={isFieldError(FORM_VALUE_ENUM.EMAIL)}
                />
                <SelectElem
                  name={FORM_VALUE_ENUM.ROLE}
                  onChange={setFieldValue}
                  options={USER_ROLE_OPTION_LIST}
                  title="USER.CREATE.FORM.ROLE"
                  errorMessage={getFieldError(FORM_VALUE_ENUM.ROLE)}
                  error={isFieldError(FORM_VALUE_ENUM.ROLE)}
                  value={setValue(USER_ROLE_OPTION_LIST, FORM_VALUE_ENUM.ROLE)}
                />
              </DoubleContainerElem>
              <DoubleContainerElem>
                <FieldPasswordElem
                  name={FORM_VALUE_ENUM.PASSWORD}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  title="USER.CREATE.FORM.PASSWORD"
                  value={getFieldValue(FORM_VALUE_ENUM.PASSWORD)}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.PASSWORD)}
                  error={isFieldError(FORM_VALUE_ENUM.PASSWORD)}
                />
                <FieldTextElem
                  name={FORM_VALUE_ENUM.NAME}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  title="USER.CREATE.FORM.NAME"
                  value={getFieldValue(FORM_VALUE_ENUM.NAME)}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.NAME)}
                  error={isFieldError(FORM_VALUE_ENUM.NAME)}
                />
              </DoubleContainerElem>
              <DoubleContainerElem>
                <FieldNumberElem
                  name={FORM_VALUE_ENUM.TELEGRAM_ID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  title="USER.CREATE.FORM.TELEGRAM_ID"
                  value={getFieldValue(FORM_VALUE_ENUM.TELEGRAM_ID)}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.TELEGRAM_ID)}
                  error={isFieldError(FORM_VALUE_ENUM.TELEGRAM_ID)}
                />
                <SelectPreloadContainer
                  name={FORM_VALUE_ENUM.PROJECT}
                  action={getProjectList}
                  convert={convertProjectListToSelect}
                  title="USER.CREATE.FORM.PROJECT"
                  onChange={setFieldValue}
                  errorMessage={getFieldError(FORM_VALUE_ENUM.PROJECT)}
                  error={isFieldError(FORM_VALUE_ENUM.PROJECT)}
                  placeholder=""
                  dynamic
                />
              </DoubleContainerElem>
              <DoubleContainerElem>
                <ButtonElem
                  type="submit"
                  tid="USER.CREATE.ADD"
                  // fill="solid"
                  disabled={isSubmitDisabled()}
                  iconRight={sendIcon}
                />
              </DoubleContainerElem>
            </GridElem>
            {isError && <AlertActionElem text={i18n.t(`${errorMessage}`)} />}
          </ContentContainerElem>
        </FormElem>
      ) : (
        <AddContainer onClick={() => setFormVisible(true)}>
          <TextElem tid="USER.CREATE.ADD" type="semi-bold" size="main" />
          <AddIconLarge />
        </AddContainer>
      )}
    </>
  );
};

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddContainer = styled(TitleContainer)`
  padding: ${Spacing(4)} ${Spacing(5)};
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme[COLOR_ENUM.BORDER]};
  border-radius: ${SIZE_BORDER_RADIUS_DATA[SIZE_BORDER_RADIUS_ENUM.CARD]}px;
  transition: all 0.2s;
  :hover {
    background-color: ${({ theme }) => theme[COLOR_ENUM.BACKGROUND_THIRD]};
  }
`;

const Icon = styled.img`
  cursor: pointer;
`;
